module.exports = __webpack_public_path__ + "img/hr-tree-08-a-leaves.5f7ea8c5.png";